import Query from '../../../../../components/Report';

export const query = ({ prompt_uids, platforms }) => {
    return new Query('ai-tracking-brand-product-mentions', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
    });
};

export const query_share = ({ prompt_uids }) => {
    return new Query('ai-tracking-brand-product-mentions-share', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
    });
};

function setKeywordUids(ids) {
    return `prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setPlatforms(platforms) {
    return `and platform in (${platforms.map((item) => `'${item}'`)})`;
}
